import React, { useEffect, useState } from "react";
import "./creditrefund.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Signature from "../../hooks/userSign";
import { isEmpty } from "lodash";
import { Api_Url } from "../../utils/ApiUrl";
import axios from "axios";
import { useWeb3React } from "@web3-react/core";
import { toast } from "react-toastify";
import Loader from "../../hooks/loader";
import { requestWithState } from "../../@api/requestWithState";


const Buy = ({ balance, getBalance, navigator, isPremium, fetchCreditPurchases, country, setShow5, verified, setVerified }) => {
  // console.log("premiumhere", isPremium)
  const { t } = useTranslation();
  let { account, chainId } = useWeb3React();
  const [loader, setLoader] = useState(false);
  const { userSign } = Signature();
  const [show, setShow] = useState(false);
  const [valueinput, setvalueinput] = useState("");
  const [loadingtext, setLoadingText] = useState("");
  const [projectselected, setProjectSelected] = useState("");
  const [projectselected22, setProjectSelected22] = useState("");

  const [rainRound, setRainRound] = useState(0);
  const [roundPrice, setRoundPrice] = useState(0);
  const [roundPriceAstaranova, setRoundPriceAstaranova] = useState(0);
  const [roundPriceNFA, setRoundPriceNFA] = useState(0);


  const [roundPriceincentive, setRoundPriceincentive] = useState(0);


  const [OlympusRound, setOlympusRound] = useState(0);
  const [roundPriceOlympus, setRoundPriceOlympus] = useState(0);
  const [youGet, setyourGet] = useState(0);
  const [youGet1, setyourGet1] = useState(0);
  const [valueinput1, setvalueinput1] = useState();
  const [listinAll, setlistingAll] = useState([]);
  // console.log("listheeis final one", listinAll)
  const [nameSale, setNameSaleGeneric] = useState("");
  const [roundPricegeneric, setroundPriceGeneric] = useState();
  const [imageGeneric, setimageGeneric] = useState("");
  const [purchaseLimitRain, setpurchaseLimitPeruserRain] = useState(0);

  const [purchaseLimitNFA, setpurchaseLimitPeruserNFA] = useState(0);

  const [purchaseLimitAstaranova, setpurchaseLimitPeruserAstaranova] = useState(0);

  const [purchaseLimitIncentive, setpurchaseLimitPeruserincentive] = useState(0);


  const [showverify, setShowVerify] = useState(false);

  // const [isSecondChecked, setIsSecondChecked] = useState(false);
  // const [isThirdChecked, setIsThirdChecked] = useState(false);
  const [IsTermsAccepted, setTermsAccepted] = useState(false)


  // console.log("erhterigheriogheriogeriog",nameSale)



  const [purchaseLimitMatchainFinalBuying, setpurchaseLimitPeruserMatchainFinalbuying] = useState(0);
  const [purchaseLimitAstaranovaFinalBuying, setpurchaseLimitPeruserAstaranovaFinalBuying] = useState(0);

  const [purchaseLimitNFAFinalBuying, setpurchaseLimitPeruserNFAFinalBuying] = useState(0);
  const [purchaseLimitOlympusFinalBuying, setpurchaseLimitPeruserOlympusFinalBuying] = useState(0);
  const [purchaseLimitIncentiveFinalBuying, setpurchaseLimitPeruserIncentiveFinalBuying] = useState(0);
  const [purchaseLimitRainFinalBuying, setpurchaseLimitPeruserRainFinalBuying] = useState(0);



  const [purchaseLimitMinerinalBuying, setpurchaseLimitPeruserMinerFinalBuying] = useState(0);
  const [purchaseLimitStandardFinalBuying, setpurchaseLimitPeruserStandardFinalBuying] = useState(0);
  const [purchaseLimitMegaFinalBuying, setpurchaseLimitPeruserMegaFinalBuying] = useState(0);
  const [purchaseLimitNodeFinalBuying, setpurchaseLimitPeruserNodeFinalBuying] = useState(0);
  // const [purchaseLimitAstaranovaFinalBuying, setpurchaseLimitPeruserAstaranovaFinalBuying] = useState(0);

  // console.log("finalvalue5555555",purchaseLimitAstaranovaFinalBuying);

  const [purchaseLimitGenericTotalFinalBuying, setpurchaseLimitGenericTotalFinalBuying] = useState(0);


  const [purchaseLimitOlympus, setpurchaseLimitPeruserOlympus] = useState(0);
  const [purchaseLimitMatchain, setpurchaseLimitPeruserMatchain] = useState(0);
  const [purchaseLimitNode, setpurchaseLimitPeruserNode] = useState(0);
  const [purchaseLimitMiner, setpurchaseLimitPeruserMiner] = useState(0);
  const [purchaseLimitStandered, setpurchaseLimitPeruserStandered] = useState(0);
  const [purchaseLimitMega, setpurchaseLimitPeruserMega] = useState(0);
  // const [purchaseLimitOlympus, setpurchaseLimitPeruserOlympus] = useState(0);
  const [limitpurchaseUserGeneric, setLimitPurchsePerUserGenric] = useState(0);
  const [matchainRound, setMatRound] = useState(0);
  const [roundPricematchain, setRoundPriceMatChain] = useState(0);
  // times generic states for each new sale here
  const [startTimeRain, setstartTimeRain] = useState();
  const [endTimeRain, setendTimeRain] = useState();
  const [startTimeOlym, setstartTimeOlym] = useState();
  const [endTimeOlym, setendTimeOlym] = useState();
  const [startTimeMatchain, setstartTimeMatchain] = useState();
  const [endTimeMatchain, setendTimeMatchian] = useState();
  const [allNftMiners, setAllMinerNftPrices] = useState();

  const [totalLimitrain, settotalLimitrain] = useState(0);
  const [totalLimitIncentive, settotalLimitincentive] = useState(0);
  const [totalLimitAstaranova, settotalLimitAstaranova] = useState(0);
  const [totalLimitNFA, settotalLimitNFA] = useState(0);

  const [totalLimitolympus, settotalLimitolympus] = useState(0);
  const [totalLimitmatchain, settotalLimitmatchain] = useState(0);

  const [totalLimitNode, settotalLimitNode] = useState(0);
  const [totalLimitMiner, settotalLimitMiner] = useState(0);
  const [totalLimitStandered, settotalLimitStandered] = useState(0);
  const [totalLimitMega, settotalLimitMega] = useState(0);

  const [totalLimitall, settotalLimitall] = useState(0);

  const [selectedMiner, setSelectedMiner] = useState(null);
  const [selectedMiner2, setSelectedMiner2] = useState(null);

  // console.log("5444444444444444", purchaseLimitNode)
  const [creditTerms, setShowCreditTerms] = useState(false);


  const miners = [
    {
      key: "mini",
      name: "Mini Miner",
      price: allNftMiners?.miniMinerPrice,
      img: "/assets/creditrefund/buynft/gemsminers/mini.svg",
      apivalue: "MINIMINER"
    },
    {
      key: "standard",
      name: "Standard Miner",
      price: allNftMiners?.standardMinerPrice,
      img: "/assets/creditrefund/buynft/gemsminers/miner.svg",
      apivalue: "STANDARDMINER"
    },
    {
      key: "mega",
      name: "Mega Miner",
      price: allNftMiners?.megaMinerPrice,
      img: "/assets/creditrefund/buynft/gemsminers/mega.svg",
      apivalue: "MEGAMINER"
    },
    {
      key: "node",
      name: "Gems Nodes",
      price: allNftMiners?.nodePrice,
      img: "/nft-img/gemsnodemainnew.png",
      apivalue: "NODE"
    },
  ];

  // miners inremenet all
  const [quantity, setQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalPriceM, setTotalPriceM] = useState(0);
  const [totalIncrementCount, setTotalIncrementCount] = useState(0);
  const [totalIncrementCountM, setTotalIncrementCountM] = useState(0);


  // matchain increments all
  const [quantitys, setQuantitys] = useState(0);
  const [totalPrices, setTotalPrices] = useState(0);
  const [totalPricesM, setTotalPricesM] = useState(0);
  const [totalIncrementCounts, setTotalIncrementCounts] = useState(0);
  const [totalIncrementCountsM, setTotalIncrementCountsM] = useState(0);



  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(true);

  const [openedModal, setOpenedModal] = useState(0)

  // console.log("finalvalue here is", quantity, totalPrice, totalIncrementCount)


  //Luckify

  const [roundPriceLuckify, setRoundPriceLuckify] = useState(0);
  const [purchaseLimitPeruserFinaLuckifylBuying, setPurchaseLimitPeruserFinaLuckifylBuying] = useState(0);
  const [purchaseLimitPeruserLuckify, setpurchaseLimitPeruserLuckify] = useState(0);
  const [totalLimitLuckify, settotalLimitLuckify] = useState(0);


  // Node Miner NFT Increment Start Here
  const increment = () => {
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    setTotalPrice(newQuantity * selectedMiner?.price);
    setTotalIncrementCount(prev => prev + 1);
  };

  const decrement = () => {
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      setTotalPrice(newQuantity * selectedMiner?.price);
      setTotalIncrementCount(prev => (prev > 0 ? prev - 1 : 0));
    }
  };

  useEffect(() => {
    if (selectedMiner) {
      setTotalPrice(quantity * selectedMiner?.price);
    }
  }, [quantity, selectedMiner]);
  // Node Miner NFT Increment Ends Here

  // Matchain NFT Increment Start Here
  const increments = () => {
    const newQuantity = quantitys + 1;
    setQuantitys(newQuantity);
    setTotalPrices(newQuantity * roundPricematchain);
    setTotalIncrementCounts(prev => prev + 1);
  };

  const decrements = () => {
    if (quantitys > 0) {
      const newQuantity = quantitys - 1;
      setQuantitys(newQuantity);
      setTotalPrices(newQuantity * roundPricematchain);
      setTotalIncrementCounts(prev => (prev > 0 ? prev - 1 : 0));
    }
  };

  useEffect(() => {
    if (roundPricematchain) {
      setTotalPrice(quantitys * roundPricematchain);
    }
  }, [quantitys, roundPricematchain]);
  // Matchain NFT Increment Ends Here

  // Nodes Miner Buy Modal Starts Here
  const [buynft, setShowBuyNft] = useState(false);
  const handleCloseBuyNft = () => {
    setSelectedMiner2(selectedMiner);
    setTotalPriceM(totalPrice);
    setTotalIncrementCountM(totalIncrementCount);
    setShowBuyNft(false);
    setSelectedMiner(null);
    setTotalPrice(0)
    setTotalIncrementCount(0);
    setQuantity(0);
  }
  const handleShowBuyNft = async () => {
    if (isPremium === true) {
      setOpenedModal(1)
      handleShowVerify(1)
      //setShowBuyNft(true);
    }
    else {
      handleShow22()
    }
  }

  const handleShowBuyLuckify = async () => {
    if (isPremium === true) {
      setOpenedModal(1)
      handleShowVerify(1)
      //setShowBuyNft(true);
    }
    else {
      handleShow22()
    }

  }
  const [show122, setShow122] = useState(false);
  const handleClose122 = () => {
    // setShow5(true)
    if (selectedMiner2?.key === "node") {
      fetchRoundNodeminerData();
      setShow122(false);
      setSelectedMiner2(null);
      setTotalIncrementCountM(0);
      setTotalPriceM(0);
      getBalance();
      fetchCreditPurchases();
    }
    else if (selectedMiner2?.key === "mini") {
      fetchRoundMinersData();
      setShow122(false);
      setSelectedMiner2(null);
      setTotalIncrementCountM(0);
      setTotalPriceM(0);
      getBalance();
      fetchCreditPurchases();
    }
    else if (selectedMiner2?.key === "mega") {
      fetchRoundMegaMinerData();
      setShow122(false);
      setSelectedMiner2(null);
      setTotalIncrementCountM(0);
      setTotalPriceM(0);
      getBalance();
      fetchCreditPurchases();
    }
    else if (selectedMiner2?.key === "standard") {
      fetchRoundStabdereMinerData();
      setShow122(false);
      setSelectedMiner2(null);
      setTotalIncrementCountM(0);
      setTotalPriceM(0);
      getBalance();
      fetchCreditPurchases();
    }
    else {
      fetchRoundNodeminerData();
      fetchRoundStabdereMinerData();
      fetchRoundMegaMinerData();
      fetchRoundMinersData();
      setShow122(false);
      setSelectedMiner2(null);
      setTotalIncrementCountM(0);
      setTotalPriceM(0);
      getBalance();
      fetchCreditPurchases();
    }

  }
  const handleShow122 = async () => {
    setShow122(true);
  }
  // Nodes Miner Buy Modal Ends Here


  // Matchain Nft Buy Modals Start Here
  const [show1222, setShow1222] = useState(false);
  const handleClose1222 = () => {
    // setShow5(true)
    fetchRoundMatchainData();
    setShow1222(false);
    setTotalIncrementCountsM(0);
    setTotalPricesM(0);
    getBalance();
    fetchCreditPurchases();
  }
  const handleShow1222 = async () => {
    setShow1222(true);
  }

  const [buynftmatchain, setShowBuyNftMatchain] = useState(false);
  const handleCloseBuyNftMatchain = () => {
    // console.log("saasaasas")
    setTotalIncrementCountsM(totalIncrementCounts);
    setTotalPricesM(totalPrices);
    setShowBuyNftMatchain(false);
    setTotalIncrementCounts(0);
    setTotalPrices(0);
    setQuantitys(0);
  }
  const handleShowBuyNftMatchain = async () => {
    if (isPremium === true) {
      // setShowBuyNftMatchain(true);
      setOpenedModal(2)
      handleShowVerify(2)
    }
    else {
      handleShow22()
    }
  }
  // Matchain Nft Buy Modals Ends Here


  // premium modal Starts here
  const [show22, setShow22] = useState(false);
  const handleClose22 = () => {
    setShow22(false);
  }
  const handleShow22 = async () => {
    setShow22(true);
  }
  // premium modal Ends here


  // All Token Rain Olympus Modal Start here
  const handleClose = () => {
    setProjectSelected22(projectselected);
    setvalueinput1(valueinput);
    setyourGet1(youGet);
    setProjectSelected("");
    setShow(false);
    setvalueinput();
    setyourGet(0);
  }
  const handleShow = async (selecetde, nameSale, roundPrice, imagegeneric, limitpurchasehere, totallimit, totalfinalbuyinglimit, opened) => {
    console.log("hello")

    if (isPremium === true) {
      setpurchaseLimitGenericTotalFinalBuying(totalfinalbuyinglimit)
      setNameSaleGeneric(nameSale);
      setroundPriceGeneric(roundPrice);
      setimageGeneric(imagegeneric);
      setProjectSelected(selecetde);
      setLimitPurchsePerUserGenric(limitpurchasehere)
      settotalLimitall(totallimit);
      console.log(opened, "openedModal")
      setOpenedModal(opened)
      handleShowVerify(opened)
      // setShow(true);
    }
    else {
      handleShow22()
    }
  }
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    // setShow5(true)
    if (projectselected22 === "RAIN") {
      fetchRoundRainData();
      setShow1(false);
      setvalueinput1();
      setyourGet1(0);
      getBalance();
      fetchCreditPurchases();
      setProjectSelected22("");
    }
    else if (projectselected22 === "ASTRANOVA") {
      fetchRoundAstronovaData();
      setShow1(false);
      setvalueinput1();
      setyourGet1(0);
      getBalance();
      fetchCreditPurchases();
      setProjectSelected22("");
    }
    else if (projectselected22 === "OLYMPUS") {
      fetchRoundOLYMPUSData();
      setShow1(false);
      setvalueinput1();
      setyourGet1(0);
      getBalance();
      fetchCreditPurchases();
      setProjectSelected22("");
    }
    else if (projectselected22 === "INCENTIV") {
      fetchRoundIncentiveData();
      setShow1(false);
      setvalueinput1();
      setyourGet1(0);
      getBalance();
      fetchCreditPurchases();
      setProjectSelected22("");
    }
    else if (projectselected22 === "NFA") {
      fetchRoundNFAData();
      setShow1(false);
      setvalueinput1();
      setyourGet1(0);
      getBalance();
      fetchCreditPurchases();
      setProjectSelected22("");
    }
    else {
      fetchRoundRainData();
      fetchRoundAstronovaData();
      fetchRoundOLYMPUSData();
      fetchRoundIncentiveData();
      fetchRoundNFAData();
      setShow1(false);
      setvalueinput1();
      setyourGet1(0);
      getBalance();
      fetchCreditPurchases();
      setProjectSelected22("");
    }

  }
  const handleShow1 = () => setShow1(true);
  // All Token Rain Olympus Modal Ends here


  const [status11, setStatus11] = useState("");
  const [day11, setDay11] = useState(0);
  const [hour11, setHour11] = useState(0);
  const [min11, setMin11] = useState(0);
  const [sec11, setSec11] = useState(0);

  useEffect(() => {
    const startTime = 1745244060000; // Start timestamp
    const endTime = 1745848800000;   // End timestamp
    const interval = setInterval(() => {
      const now = new Date().getTime();
      let targetTime;
      let newStatus;
      if (now < startTime) {
        targetTime = startTime;
        newStatus = "Round Starts In";
      } else if (now >= startTime && now < endTime) {
        targetTime = endTime;
        newStatus = "Round Ends In";
      } else {
        targetTime = now;
        newStatus = "Ended";
      }
      const diff = targetTime - now;
      if (newStatus === "Ended") {
        clearInterval(interval);
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      setDay11(days);
      setHour11(hours);
      setMin11(mins);
      setSec11(secs);
      setStatus11(newStatus);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const [status12, setStatus12] = useState("");
  const [day12, setDay12] = useState(0);
  const [hour12, setHour12] = useState(0);
  const [min12, setMin12] = useState(0);
  const [sec12, setSec12] = useState(0);

  useEffect(() => {
    const startDate = startTimeMatchain;
    const endDate = endTimeMatchain;
    const startTime = new Date(startDate).getTime(); // Convert ISO to timestamp
    const endTime = new Date(endDate).getTime();     // Convert ISO to timestamp
    const interval = setInterval(() => {
      const now = new Date().getTime();
      let targetTime;
      let newStatus;
      if (now < startTime) {
        targetTime = startTime;
        newStatus = "Round Starts In";
      } else if (now >= startTime && now < endTime) {
        targetTime = endTime;
        newStatus = "Round Ends In";
      } else {
        targetTime = now;
        newStatus = "Ended";
      }
      const diff = targetTime - now;
      if (newStatus === "Ended") {
        clearInterval(interval);
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      setDay12(days);
      setHour12(hours);
      setMin12(mins);
      setSec12(secs);
      setStatus12(newStatus);
    }, 1000);
    return () => clearInterval(interval);
  }, [startTimeMatchain, endTimeMatchain]);

  const [status1, setStatus1] = useState("");
  const [day1, setDay1] = useState(0);
  const [hour1, setHour1] = useState(0);
  const [min1, setMin1] = useState(0);
  const [sec1, setSec1] = useState(0);

  useEffect(() => {
    const startDate = startTimeOlym;
    const endDate = endTimeOlym;
    const startTime = new Date(startDate).getTime(); // Convert ISO to timestamp
    const endTime = new Date(endDate).getTime();     // Convert ISO to timestamp
    const interval = setInterval(() => {
      const now = new Date().getTime();
      let targetTime;
      let newStatus;
      if (now < startTime) {
        targetTime = startTime;
        newStatus = "Round Starts In";
      } else if (now >= startTime && now < endTime) {
        targetTime = endTime;
        newStatus = "Round Ends In";
      } else {
        targetTime = now;
        newStatus = "Ended";
      }
      const diff = targetTime - now;
      if (newStatus === "Ended") {
        clearInterval(interval);
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      setDay1(days);
      setHour1(hours);
      setMin1(mins);
      setSec1(secs);
      setStatus1(newStatus);
    }, 1000);
    return () => clearInterval(interval);
  }, [startTimeOlym, endTimeOlym]);

  const [status, setStatus] = useState("");
  const [day1r, setDay1r] = useState(0);
  const [hour1r, setHour1r] = useState(0);
  const [min1r, setMin1r] = useState(0);
  const [sec1r, setSec1r] = useState(0);

  useEffect(() => {
    const startDate = startTimeRain; // Replace with your actual start date string
    const endDate = endTimeRain;   // Replace with your actual end date string
    const startTime = new Date(startDate).getTime();
    const endTime = new Date(endDate).getTime();
    // console.log("asasfasdasdasdasd", startTime, endTime)
    const interval = setInterval(() => {
      const now = new Date().getTime();
      let targetTime;
      let newStatus;
      if (now < startTime) {
        targetTime = startTime;
        newStatus = "Round Starts In";
      } else if (now >= startTime && now < endTime) {
        targetTime = endTime;
        newStatus = "Round Ends In";
      } else {
        targetTime = now;
        newStatus = "Ended";
      }
      const diff = targetTime - now;
      if (newStatus === "Ended") {
        clearInterval(interval);
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      setDay1r(days);
      setHour1r(hours);
      setMin1r(mins);
      setSec1r(secs);
      setStatus(newStatus);
    }, 1000);
    return () => clearInterval(interval);
  }, [startTimeRain, endTimeRain]);



  const fetchRoundRainData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: {
          privateSale: "RAIN",
          by: account?.toLocaleLowerCase()
        },
      });
      // setRainRound(response?.data?.data?.saleRound?.round);
      setRoundPrice(response?.data?.data?.saleRound?.salePrice);
      // setstartTimeRain(response?.data?.data?.saleRound?.startDate);
      // setendTimeRain(response?.data?.data?.saleRound?.endDate);
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;

      setpurchaseLimitPeruserRainFinalBuying(d - c);

      setpurchaseLimitPeruserRain(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitrain(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundLuckifyData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: {
          privateSale: "LUCKIFY",
          by: account?.toLocaleLowerCase()
        },
      });
      // setRainRound(response?.data?.data?.saleRound?.round);
      setRoundPriceLuckify(response?.data?.data?.saleRound?.salePrice);
      // setstartTimeRain(response?.data?.data?.saleRound?.startDate);
      // setendTimeRain(response?.data?.data?.saleRound?.endDate);
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;

      setPurchaseLimitPeruserFinaLuckifylBuying(d - c);

      setpurchaseLimitPeruserLuckify(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitLuckify(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };
  // --------------------
  // 🟣 SCREX STATES
  // --------------------
  const [roundPriceScrex, setRoundPriceScrex] = useState(0);
  const [purchaseLimitPeruserFinalScrexBuying, setPurchaseLimitPeruserFinalScrexBuying] = useState(0);
  const [purchaseLimitPeruserScrex, setPurchaseLimitPeruserScrex] = useState(0);
  const [totalLimitScrex, setTotalLimitScrex] = useState(0);
  // Optionally, if you want to track round or time data later:
  // const [roundScrex, setRoundScrex] = useState(null);
  // const [startTimeScrex, setStartTimeScrex] = useState(null);
  // const [endTimeScrex, setEndTimeScrex] = useState(null);

  // --------------------
  // 🟣 SCREX FETCH FUNCTION
  // --------------------
  const fetchRoundScrexData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: {
          privateSale: "SCREX",
          by: account?.toLocaleLowerCase(),
        },
      });

      // Round price
      setRoundPriceScrex(response?.data?.data?.saleRound?.salePrice);

      // User purchase limit
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setPurchaseLimitPeruserFinalScrexBuying(d - c);
      setPurchaseLimitPeruserScrex(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);

      // Total limit remaining
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      setTotalLimitScrex(b - a);

      // Optional:
      // setRoundScrex(response?.data?.data?.saleRound?.round);
      // setStartTimeScrex(response?.data?.data?.saleRound?.startDate);
      // setEndTimeScrex(response?.data?.data?.saleRound?.endDate);

    } catch (err) {
      console.error("Error fetching Screx round data:", err);
    }
  };

  const handleCloseCreditTerms = (flag) => {
    if (flag) {
      handleCloseVerify(true)
    }
    else {
      setEmail("")
    }
    setShowCreditTerms(false);
    setTermsAccepted(false);
    // setIsSecondChecked(false)
    // setIsThirdChecked(false)
  };

  const fetchRoundAstronovaData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: {
          privateSale: "ASTRANOVA",
          by: account?.toLocaleLowerCase()
        },
      });
      // setRainRound(response?.data?.data?.saleRound?.round);
      setRoundPriceAstaranova(response?.data?.data?.saleRound?.salePrice);
      // setstartTimeRain(response?.data?.data?.saleRound?.startDate);
      // setendTimeRain(response?.data?.data?.saleRound?.endDate);
      // const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchasedByUser;
      // const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser;
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      // console.log("sddddddddddddddddddddd", c , d, d -c)

      setpurchaseLimitPeruserAstaranovaFinalBuying(d - c)
      setpurchaseLimitPeruserAstaranova(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;

      settotalLimitAstaranova(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundNFAData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: { privateSale: "NFA", by: account?.toLocaleLowerCase() },
      });
      // setRainRound(response?.data?.data?.saleRound?.round);
      setRoundPriceNFA(response?.data?.data?.saleRound?.salePrice);
      // setstartTimeRain(response?.data?.data?.saleRound?.startDate);
      // setendTimeRain(response?.data?.data?.saleRound?.endDate);
      // const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchasedByUser;
      // const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser;
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setpurchaseLimitPeruserNFAFinalBuying(d - c);
      setpurchaseLimitPeruserNFA(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitNFA(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundIncentiveData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: { privateSale: "INCENTIV", by: account?.toLocaleLowerCase() },
      });
      // setRainRound(response?.data?.data?.saleRound?.round);
      setRoundPriceincentive(response?.data?.data?.saleRound?.salePrice);
      // setstartTimeRain(response?.data?.data?.saleRound?.startDate);
      // setendTimeRain(response?.data?.data?.saleRound?.endDate);
      // const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchasedByUser;
      // const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser;
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setpurchaseLimitPeruserIncentiveFinalBuying(d - c);
      setpurchaseLimitPeruserincentive(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitincentive(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundMatchainData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: { privateSale: "MATCHAIN", by: account?.toLocaleLowerCase() },
      });
      // setMatRound(response?.data?.data?.saleRound?.round);
      setRoundPriceMatChain(response?.data?.data?.saleRound?.salePrice);
      // setstartTimeMatchain(response?.data?.data?.saleRound?.startDate);
      // console.log("amatcgain here is", response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser , d , c)
      // setendTimeMatchian(response?.data?.data?.saleRound?.endDate);
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setpurchaseLimitPeruserMatchainFinalbuying(d - c);
      setpurchaseLimitPeruserMatchain(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitmatchain(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundOLYMPUSData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: { privateSale: "OLYMPUS", by: account?.toLocaleLowerCase() },
      });
      // setOlympusRound(response?.data?.data?.saleRound?.round);
      setRoundPriceOlympus(response?.data?.data.saleRound?.salePrice);
      // setstartTimeOlym(response?.data?.data?.saleRound?.startDate);
      // setendTimeOlym(response?.data?.data?.saleRound?.endDate);
      // const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchasedByUser;
      // const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser;
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setpurchaseLimitPeruserOlympusFinalBuying(d - c);
      setpurchaseLimitPeruserOlympus(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitolympus(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundMinersData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: { privateSale: "MINIMINER", by: account?.toLocaleLowerCase() },
      });
      // const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchasedByUser;
      // const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser;
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setpurchaseLimitPeruserMinerFinalBuying(d - c);
      setpurchaseLimitPeruserMiner(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitMiner(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundStabdereMinerData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: { privateSale: "STANDARDMINER", by: account?.toLocaleLowerCase() },
      });
      // const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchasedByUser;
      // const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser;
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setpurchaseLimitPeruserStandardFinalBuying(d - c);
      setpurchaseLimitPeruserStandered(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitStandered(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundMegaMinerData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: { privateSale: "MEGAMINER", by: account?.toLocaleLowerCase() },
      });
      // const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchasedByUser;
      // const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser;
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setpurchaseLimitPeruserMegaFinalBuying(d - c);
      setpurchaseLimitPeruserMega(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitMega(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchRoundNodeminerData = async () => {
    try {
      const response = await axios.get(`${Api_Url}/credit/purchase/data`, {
        params: { privateSale: "NODE", by: account?.toLocaleLowerCase() },
      });
      // const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchasedByUser;
      // const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser;
      const c = response?.data?.data?.tokenPurchasedByUser?.[0]?.tokenPurchased || 0;
      const d = response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser || 0;
      setpurchaseLimitPeruserNodeFinalBuying(d - c);
      setpurchaseLimitPeruserNode(response?.data?.data?.projectValues?.[0]?.purchaseLimitPerUser);
      const a = response?.data?.data?.tokenPurchased?.[0]?.tokenPurchased || 0;
      const b = response?.data?.data?.projectValues?.[0]?.purchaseLimit;
      settotalLimitNode(b - a);
      // setRoundData(response.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  // useEffect(() => {

  // }, []);

  useEffect(() => {
    if (account) {
      fetchRoundMatchainData();
      fetchRoundOLYMPUSData();
      fetchRoundRainData();
      fetchRoundLuckifyData();
      fetchRoundScrexData()
      fetchRoundAstronovaData();
      fetchRoundIncentiveData();
      fetchRoundMinersData();
      fetchRoundStabdereMinerData();
      fetchRoundMegaMinerData();
      fetchRoundNodeminerData();
      fetchRoundNFAData();
    }

  }, [account]);

  const MaxFunc = () => {
    setvalueinput(balance)
  }
  const [inputError, setInputError] = useState("");
  const [isInputError, setIsInputError] = useState(false); // for disabling button
  const [inputErrorr, setInputErrorr] = useState("");
  const [isInputErrorr, setIsInputErrorr] = useState(false); // for disabling button
  const [inputErrorrr, setInputErrorrr] = useState("");
  const [isInputErrorrr, setIsInputErrorrr] = useState(false); // for disabling button

  const [color, setcolor] = useState(false);
  const [colorr, setcolorr] = useState(false);
  const [colorrr, setcolorrr] = useState(false);

  // All token buy validations
  useEffect(() => {
    if (!valueinput || isNaN(valueinput)) {
      setInputError("");
      setIsInputError(true);
      setcolor(false);
      return;
    }

    const input = parseFloat(valueinput);

    if (input <= 0) {
      setInputError(t('Cre109'));
      setIsInputError(true);
      setcolor(true);
      return;
    }

    if (!account) {
      setInputError(t('Cre110'));
      setIsInputError(true);
      setcolor(true);
      return;
    }

    const price = parseFloat(roundPricegeneric);
    const ratio = input / price;

    if (
      nameSale === "Mat Chain" &&
      !Number.isNaN(ratio) &&
      !Number.isInteger(ratio)
    ) {
      setInputError(`${t('Cre118')} ${roundPricegeneric}`);
      setIsInputError(true);
      setcolor(true);
    } else if (youGet > totalLimitall) {
      setInputError(t('Cre112'));
      setIsInputError(true);
      setcolor(true);

    } else if (youGet > limitpurchaseUserGeneric) {
      setInputError(t('Cre112'));
      setIsInputError(true);
      setcolor(true);
    }
    else if (youGet > purchaseLimitGenericTotalFinalBuying) {
      setInputError(t('Cre113'));
      setIsInputError(true);
      setcolor(true);
    }

    else if (input > balance) {
      setInputError(t('Cre114'));
      setIsInputError(true);
      setcolor(true);

    } else {
      setInputError("");
      setIsInputError(false);
      setcolor(false);

    }
  }, [
    valueinput,
    roundPricegeneric,
    youGet,
    totalLimitall,
    limitpurchaseUserGeneric,
    balance,
    nameSale,
  ]);


  // node miner nft validations
  useEffect(() => {
    // console.log("909090909090909", totalPrice, totalIncrementCount, purchaseLimitMiner);

    if (!selectedMiner) {
      setInputErrorr("");
      setIsInputErrorr(true);
      setcolorr(false);
      return;
    }
    if (selectedMiner?.key === "node" && totalIncrementCount > totalLimitNode) {
      setInputErrorr(t('Cre112'));
      setIsInputErrorr(true);
      setcolorr(true);
    }
    else if (selectedMiner?.key === "mini" && totalIncrementCount > totalLimitMiner) {
      setInputErrorr(t('Cre112'));
      setIsInputErrorr(true);
      setcolorr(true);
    }
    else if (selectedMiner?.key === "standard" && totalIncrementCount > totalLimitStandered) {
      setInputErrorr(t('Cre112'));
      setIsInputErrorr(true);
      setcolorr(true);
    }
    else if (selectedMiner?.key === "mega" && totalIncrementCount > totalLimitMega) {
      setInputErrorr(t('Cre112'));
      setIsInputErrorr(true);
      setcolorr(true);
    }
    else if (selectedMiner?.key === "node" && totalIncrementCount > purchaseLimitNode) {
      setInputErrorr(t('Cre112'));
      setIsInputErrorr(true);
      setcolorr(true);
    } else if (selectedMiner?.key === "mini" && totalIncrementCount > purchaseLimitMiner) {
      setInputErrorr(t('Cre112'));
      setIsInputErrorr(true);
      setcolorr(true);
    } else if (selectedMiner?.key === "standard" && totalIncrementCount > purchaseLimitStandered) {
      setInputErrorr(t('Cre112'));
      setIsInputErrorr(true);
      setcolorr(true);

    } else if (selectedMiner?.key === "mega" && totalIncrementCount > purchaseLimitMega) {
      setInputErrorr(t('Cre112'));
      setIsInputErrorr(true);
      setcolorr(true);
    }
    else if (selectedMiner?.key === "mega" && totalIncrementCount > purchaseLimitMegaFinalBuying) {
      setInputErrorr(t('Cre113'));
      setIsInputErrorr(true);
      setcolorr(true);
    }
    else if (selectedMiner?.key === "mini" && totalIncrementCount > purchaseLimitMinerinalBuying) {
      setInputErrorr(t('Cre113'));
      setIsInputErrorr(true);
      setcolorr(true);
    } else if (selectedMiner?.key === "standard" && totalIncrementCount > purchaseLimitStandardFinalBuying) {
      setInputErrorr(t('Cre113'));
      setIsInputErrorr(true);
      setcolorr(true);
    }
    else if (selectedMiner?.key === "node" && totalIncrementCount > purchaseLimitNodeFinalBuying) {
      setInputErrorr(t('Cre113'));
      setIsInputErrorr(true);
      setcolorr(true);
    }

    else if (totalPrice === 0) {
      setInputErrorr("");
      setIsInputErrorr(true);
      setcolorr(false);
    }
    else if (totalPrice > balance) {
      setInputErrorr(t('Cre114'));
      setIsInputErrorr(true);
      setcolorr(true);
    }
    else {
      setInputErrorr("");
      setIsInputErrorr(false);
      setcolorr(false);
    }
  }, [
    totalPrice,
    balance,
    selectedMiner,
  ]);


  // matchain nft validations
  useEffect(() => {
    // console.log("909090909090909", totalPrice, purchaseLimitMatchain, purchaseLimitMatchainFinalBuying);

    if (!totalPrices) {
      setInputErrorrr("");
      setIsInputErrorrr(true);
      setcolorrr(false);
      return;
    }

    if (totalIncrementCounts > totalLimitmatchain) {
      setInputErrorrr(t('Cre112'));
      setIsInputErrorrr(true);
      setcolorrr(true);
    }

    else if (totalIncrementCounts > purchaseLimitMatchain) {
      setInputErrorrr(t('Cre112'));
      setIsInputErrorrr(true);
      setcolorrr(true);
    }
    else if (totalIncrementCounts > purchaseLimitMatchainFinalBuying) {
      setInputErrorrr(t('Cre113'));
      setIsInputErrorrr(true);
      setcolorrr(true);
    }

    // else if(purchaseLimitMatchain )
    else if (totalPrices === 0) {
      setInputErrorrr("");
      setIsInputErrorrr(true);
      setcolorrr(false);
    }
    else if (totalPrices > balance) {
      setInputErrorrr(t('Cre114'));
      setIsInputErrorrr(true);
      setcolorrr(true);
    }
    else {
      setInputErrorrr("");
      setIsInputErrorrr(false);
      setcolorrr(false);
    }
  }, [
    totalPrices,
    balance,
    roundPricematchain,
  ]);




  // console.log("44444444444555555555", isInputError)

  // Token Buy Functions
  const Purchasetoken = async () => {
    try {
      setLoader(true);
      if (account) {
        const SignatureValueExist = localStorage.getItem("signaturevalue")
        const AccountOldHere = localStorage.getItem("accountold")
        if (SignatureValueExist === null || SignatureValueExist === undefined || SignatureValueExist === isEmpty || SignatureValueExist === " ") {
          try {
            setLoadingText(t('Cre116'))
            const sign = await userSign();
            if (sign) {
              localStorage.setItem("signaturevalue", sign)
              localStorage.setItem("accountold", account)
              try {
                // let country = localStorage.getItem("country");
                const res = await axios.post(`${Api_Url}/credit/credit-purchase`, {
                  privateSale: projectselected,
                  walletAddress: account?.toLowerCase(),
                  creditAmound: parseFloat(valueinput),
                  country: country,
                  sign: sign
                });
                if (res) {
                  handleClose();
                  handleShow1();
                  // fetchCreditPurchases();
                  // getBalance();
                  setLoader(false);
                }
              } catch (err) {
                setLoader(false);
                toast.error(
                  err?.response?.data?.message
                );
              }
            }
          } catch (err) {
            setLoader(false);
            toast.error(
              err.message
            );
          }
        }
        else {
          if (SignatureValueExist && account.toLocaleLowerCase() === AccountOldHere.toLocaleLowerCase()) {
            try {
              setLoader(true);
              // let country = localStorage.getItem("country");
              const res = await axios.post(`${Api_Url}/credit/credit-purchase`, {
                privateSale: projectselected,
                walletAddress: account?.toLowerCase(),
                creditAmound: parseFloat(valueinput),
                country: country,
                sign: SignatureValueExist
              });
              if (res) {
                handleClose();
                handleShow1();
                // getBalance();
                // fetchCreditPurchases();
                setLoader(false);
              }
            } catch (err) {
              setLoader(false);
              toast.error(
                err?.response?.data?.message
              );
            }
          }
          else {
            try {
              setLoadingText(t('Cre116'))
              const sign = await userSign();
              if (sign) {
                localStorage.setItem("signaturevalue", sign)
                localStorage.setItem("accountold", account)
                try {
                  // let country = localStorage.getItem("country");
                  const res = await axios.post(`${Api_Url}/credit/credit-purchase`, {
                    privateSale: projectselected,
                    walletAddress: account?.toLowerCase(),
                    creditAmound: parseFloat(valueinput),
                    country: country,
                    sign: sign
                  });
                  if (res) {
                    handleClose();
                    handleShow1();
                    // getBalance();
                    // fetchCreditPurchases();
                    setLoader(false);
                  }
                } catch (err) {
                  setLoader(false);
                  toast.error(
                    err?.response?.data?.message
                  );
                }
              }
            } catch (err) {
              setLoader(false);
              toast.error(
                err.message
              );
            }
          }
        }
      }
      else {
        toast.error(
          t('Cre110')
        );
        setLoader(false);
      }
    }
    catch (err) {
      setLoader(false);

      toast.error(err.message);
    }
  }
  // Nft Node Miner Buy Functions
  const PurchaseNFTNodeMiner = async () => {
    try {
      setLoader(true);
      if (account) {
        const SignatureValueExist = localStorage.getItem("signaturevalue")
        const AccountOldHere = localStorage.getItem("accountold")
        if (SignatureValueExist === null || SignatureValueExist === undefined || SignatureValueExist === isEmpty || SignatureValueExist === " ") {
          try {
            setLoadingText(t('Cre116'))
            const sign = await userSign();
            if (sign) {
              localStorage.setItem("signaturevalue", sign)
              localStorage.setItem("accountold", account)
              try {
                // let country = localStorage.getItem("country");
                const res = await axios.post(`${Api_Url}/credit/purchase/node/miner`, {
                  privateSale: selectedMiner?.apivalue,
                  walletAddress: account?.toLowerCase(),
                  creditAmound: parseFloat(totalPrice),
                  country: country,
                  sign: sign
                });
                if (res) {
                  handleCloseBuyNft();
                  handleShow122();
                  setLoader(false);
                }
              } catch (err) {
                setLoader(false);
                toast.error(
                  err?.response?.data?.message
                );
              }
            }
          } catch (err) {
            setLoader(false);
            toast.error(
              err.message
            );
          }
        }
        else {
          if (SignatureValueExist && account.toLocaleLowerCase() === AccountOldHere.toLocaleLowerCase()) {
            try {
              setLoader(true);
              // let country = localStorage.getItem("country");
              const res = await axios.post(`${Api_Url}/credit/purchase/node/miner`, {
                privateSale: selectedMiner?.apivalue,
                walletAddress: account?.toLowerCase(),
                creditAmound: parseFloat(totalPrice),
                country: country,
                sign: SignatureValueExist
              });
              if (res) {
                handleCloseBuyNft();
                handleShow122();
                setLoader(false);
              }
            } catch (err) {
              setLoader(false);
              toast.error(
                err?.response?.data?.message
              );
            }
          }
          else {
            try {
              setLoadingText(t('Cre116'))
              const sign = await userSign();
              if (sign) {
                localStorage.setItem("signaturevalue", sign)
                localStorage.setItem("accountold", account)
                try {
                  // let country = localStorage.getItem("country");
                  const res = await axios.post(`${Api_Url}/credit/purchase/node/miner`, {
                    privateSale: selectedMiner?.apivalue,
                    walletAddress: account?.toLowerCase(),
                    creditAmound: parseFloat(totalPrice),
                    country: country,
                    sign: sign
                  });
                  if (res) {
                    handleCloseBuyNft();
                    handleShow122();
                    setLoader(false);
                  }
                } catch (err) {
                  setLoader(false);
                  toast.error(
                    err?.response?.data?.message
                  );
                }
              }
            } catch (err) {
              setLoader(false);
              toast.error(
                err.message
              );
            }
          }
        }
      }
      else {
        toast.error(
          t('Cre110')
        );
        setLoader(false);
      }
    }
    catch (err) {
      toast.error(err.message);
      setLoader(false);

    }
  }
  // MatChain Buy Functions
  const PurchaseMatChainNft = async () => {
    try {
      setLoader(true);
      if (account) {
        const SignatureValueExist = localStorage.getItem("signaturevalue")
        const AccountOldHere = localStorage.getItem("accountold")
        if (SignatureValueExist === null || SignatureValueExist === undefined || SignatureValueExist === isEmpty || SignatureValueExist === " ") {
          try {
            setLoadingText(t('Cre116'))
            const sign = await userSign();
            if (sign) {
              localStorage.setItem("signaturevalue", sign)
              localStorage.setItem("accountold", account)
              try {
                // let country = localStorage.getItem("country");
                const res = await axios.post(`${Api_Url}/credit/credit-purchase`, {
                  privateSale: "MATCHAIN",
                  walletAddress: account?.toLowerCase(),
                  creditAmound: parseFloat(totalPrices),
                  country: country,
                  sign: sign
                });
                if (res) {
                  handleCloseBuyNftMatchain();
                  handleShow1222();
                  setLoader(false);
                }
              } catch (err) {
                setLoader(false);
                toast.error(
                  err?.response?.data?.message
                );
              }
            }
          } catch (err) {
            setLoader(false);
            toast.error(
              err.message
            );
          }
        }
        else {
          if (SignatureValueExist && account.toLocaleLowerCase() === AccountOldHere.toLocaleLowerCase()) {
            try {
              setLoader(true);
              // let country = localStorage.getItem("country");
              const res = await axios.post(`${Api_Url}/credit/credit-purchase`, {
                privateSale: "MATCHAIN",
                walletAddress: account?.toLowerCase(),
                creditAmound: parseFloat(totalPrices),
                country: country,
                sign: SignatureValueExist
              });
              if (res) {
                handleCloseBuyNftMatchain();
                handleShow1222();
                setLoader(false);
              }
            } catch (err) {
              setLoader(false);
              toast.error(
                err?.response?.data?.message
              );
            }
          }
          else {
            try {
              setLoadingText(t('Cre116'))
              const sign = await userSign();
              if (sign) {
                localStorage.setItem("signaturevalue", sign)
                localStorage.setItem("accountold", account)
                try {
                  // let country = localStorage.getItem("country");
                  const res = await axios.post(`${Api_Url}/credit/credit-purchase`, {
                    privateSale: "MATCHAIN",
                    walletAddress: account?.toLowerCase(),
                    creditAmound: parseFloat(totalPrices),
                    country: country,
                    sign: sign
                  });
                  if (res) {
                    handleCloseBuyNftMatchain();
                    handleShow1222();
                    setLoader(false);
                  }
                } catch (err) {
                  setLoader(false);
                  toast.error(
                    err?.response?.data?.message
                  );
                }
              }
            } catch (err) {
              setLoader(false);
              toast.error(
                err.message
              );
            }
          }
        }
      }
      else {
        toast.error(
          t('Cre110')
        );
        setLoader(false);
      }
    }
    catch (err) {
      setLoader(false);

      toast.error(err.message);
    }
  }


  const formatNumber = (num) => {
    if (num && num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    } else {
      return num?.toFixed(2)
    }
  }

  const toasterror = () => {
    toast.error(
      t('Cre110')
    );

  }

  useEffect(() => {
    setyourGet(valueinput / roundPricegeneric)
  }, [valueinput, roundPricegeneric]);

  const fetchPurchaseListingData = async () => {
    try {
      const res = await axios.get(`${Api_Url}/credit/active/projects`);
      // setlistingAll(response?.data?.data)
      const active = res.data.data.filter(item => item.isActive).map(item => item.privateSale);
      console.log("activesales",active)
      setlistingAll(active);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };
  useEffect(() => {
    fetchPurchaseListingData();
  }, []);

  const fetchPricesofNftsAllData = async () => {
    try {
      const res = await axios.get(`${Api_Url}/credit/price/node/miner`);
      // console.log("66666666666555555555",res?.data.data)
      setAllMinerNftPrices(res?.data?.data);
    } catch (err) {
      console.error("Error fetching round data:", err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };
  useEffect(() => {
    fetchPricesofNftsAllData();
  }, []);

  const handleCloseVerify = (flag, opened) => {

    console.log(flag, openedModal)
    if (flag) {
      switch (openedModal || opened) {
        case 1:
          setShowBuyNft(true);
          break;
        case 2:
          setShowBuyNftMatchain(true);
          break;
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
          setShow(true)
          break;
      }
    }
    setEmail("")
    setShowOtpInput(false)
    setShowVerify(false);
    setOtp("")
  };

  const handleShowCreditTerms = () => {
    setShowCreditTerms(true)
  }
  const handleShowVerify = (opened = 0) => {
    console.log(verified, "Verified")
    if (!verified) {
      setShowVerify(true);
    }
    else {
      console.log(openedModal, "Opened Modal")
      handleShowCreditTerms(opened)
      // handleCloseVerify(true, opened)
    }
  }

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsEmailValid(isValidEmail(value));
  };

  const [timer, setTimer] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setTimeout(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [timer, isResendDisabled]);

  const handleSendCode = async (e) => {
    e.preventDefault();
    if (!isEmailValid || isResendDisabled) return;

    try {
      const response = await requestWithState({
        url: `/emails/verify-email`,
        method: "POST",
        data: {
          email,
          by: account.toLowerCase(),
          country,
        },
      });

      console.log(response);
      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        setShowOtpInput(false);
        handleCloseVerify(true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        toast.success("Verification email sent.")
        setShowOtpInput(true);

        // Start cooldown
        setIsResendDisabled(true);
        setTimer(10);
      }
      else if (response?.statusCode === 409) {
        toast.error("Email already exists")
      }
      else if (response?.statusCode === 403) {
        toast.error("Given wallet address is associated with existing email")
      }
    } catch (error) {
      toast.error(error.message)
      console.error("Failed to send verification email:", error);
    }
  };


  const handleVerifyOtp = async () => {
    try {
      const response = await requestWithState({
        url: `/emails/verify-otp`,
        method: "POST",
        data: {
          email,
          by: account.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
        console.log("Email verified successfully");
        setIsOtpValid(true);
        handleCloseVerify(true);
        setVerified(true)
      } else {
        setIsOtpValid(false);
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      setIsOtpValid(false);
    }
  };

  if (loader) {
    return <Loader text={loadingtext} />;
  }


  return (

    <>

      <section className="credit-projects">
        <div className="custom-container padd-right-sm">
          <h4 className="buyhead">{t('Cre81')}</h4>
          <div className="bottom-cards">
            {
              listinAll?.includes("SCREX") && (
                <div
                  className="single-card"
                  style={{ opacity: totalLimitScrex < 1 && account ? 0.5 : 1 }}
                >
                  <Link to="/screx">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                  src="\assets\xenlogo.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <div className="token-info">
                      <h6>
                        XEN{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">Screx</p>
                      <p className="para">
Screx aims to provide a unified and intelligent environment for decentralized finance (DeFi) allowing users to manage their digital assets... </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                          <p>Round</p>
                          <h6>{matchainRound}</h6>
                        </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${roundPriceScrex}</h6>
                      </div>
                      {/* <div className="text">
                          <p>Total Raised</p>
                          <h6>--</h6>
                        </div> */}
                    </div>
                  </Link>

                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          if (
                            !(
                              totalLimitScrex < 1
                            )
                          ) {
                            handleShow(
                              "SCREX",
                              "Screx",
                              roundPriceScrex,
                              "/assets/alldetailpages/screx/screxlogo.svg",
                              purchaseLimitPeruserScrex,
                              totalLimitScrex,
                              purchaseLimitPeruserFinalScrexBuying,
                              8
                            );

                          }
                        }}
                        className={`btn-green ${totalLimitScrex < 1
                          ? 'fadebuttonss disabled'
                          : ''
                          }`}
                        style={{
                          pointerEvents:
                            totalLimitScrex < 1
                              ? 'none'
                              : 'auto',
                        }}
                      >
                        {totalLimitScrex < 1
                          ? 'Maxed Out'
                          : t('Btn-buynow')}
                      </a>
                    ) : (
                      <a
                        onClick={() => {
                          if (
                            !(
                              totalLimitScrex < 1
                            )
                          ) {
                            toasterror();
                          }
                        }}
                        className={`btn-green fadebuttonss ${totalLimitScrex < 1
                          ? 'disabled'
                          : ''
                          }`}
                        style={{
                          pointerEvents:
                            totalLimitScrex < 1
                              ? 'none'
                              : 'auto',
                        }}
                      >
                        {
                          t('Btn-buynow')}
                      </a>
                    )}
                  </>

                </div>
              )
            }
            {
              listinAll?.includes("LUCKIFY") && (
                <div
                  className="single-card"
                  style={{ opacity: totalLimitLuckify < 1 && account ? 0.5 : 1 }}
                >
                  <Link to="/luckify">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\alldetailpages\luckify\luckify-logo.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <div className="token-info">
                      <h6>
                        Luckify{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">LUCK</p>
                      <p className="para">
                        Luckify is redefining the world of chance-based gaming by putting fairness on-chain. From casino-style games and lotteries to...
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                          <p>Round</p>
                          <h6>{matchainRound}</h6>
                        </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${roundPriceLuckify}</h6>
                      </div>
                      {/* <div className="text">
                          <p>Total Raised</p>
                          <h6>--</h6>
                        </div> */}
                    </div>
                  </Link>

                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          if (
                            !(
                              totalLimitLuckify < 1
                            )
                          ) {
                            handleShow(
                              "LUCKIFY",
                              "Luckify",
                              roundPriceLuckify,
                              "/assets/alldetailpages/luckify/luckify-logo.svg",
                              purchaseLimitPeruserLuckify,
                              totalLimitLuckify,
                              purchaseLimitPeruserFinaLuckifylBuying,
                              8
                            );

                          }
                        }}
                        className={`btn-green ${totalLimitLuckify < 1
                          ? 'fadebuttonss disabled'
                          : ''
                          }`}
                        style={{
                          pointerEvents:
                            totalLimitLuckify < 1
                              ? 'none'
                              : 'auto',
                        }}
                      >
                        {totalLimitLuckify < 1
                          ? 'Maxed Out'
                          : t('Btn-buynow')}
                      </a>
                    ) : (
                      <a
                        onClick={() => {
                          if (
                            !(
                              totalLimitLuckify < 1
                            )
                          ) {
                            toasterror();
                          }
                        }}
                        className={`btn-green fadebuttonss ${totalLimitLuckify < 1
                          ? 'disabled'
                          : ''
                          }`}
                        style={{
                          pointerEvents:
                            totalLimitLuckify < 1
                              ? 'none'
                              : 'auto',
                        }}
                      >
                        {
                           t('Btn-buynow')}
                      </a>
                    )}
                  </>

                </div>
              )
            }
            {
              (listinAll?.includes("MINIMINER") || listinAll?.includes("STANDARDMINER") || listinAll?.includes("MEGAMINER") || listinAll?.includes("NODE")) && (
                <div
                  className="single-card"
                  style={{
                    opacity:
                      totalLimitMiner < 1 &&
                        totalLimitNode < 1 &&
                        totalLimitMega < 1 &&
                        totalLimitStandered < 1
                        && account
                        ? 0.5
                        : 1,
                  }}
                >
                  <Link to="/miners">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\alldetailpages\miners\banner\token-logo.png"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <div className="token-info">
                      <h6>
                        Gems Miners{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">GMR</p>
                      <p className="para">
                        {t('Cre82')}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                          <p>Round</p>
                          <h6>{matchainRound}</h6>
                        </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${allNftMiners?.miniMinerPrice}</h6>
                      </div>
                      {/* <div className="text">
                          <p>Total Raised</p>
                          <h6>--</h6>
                        </div> */}
                    </div>
                  </Link>

                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          if (
                            !(
                              totalLimitMiner < 1 &&
                              totalLimitNode < 1 &&
                              totalLimitMega < 1 &&
                              totalLimitStandered < 1
                            )
                          ) {
                            handleShowBuyNft();
                          }
                        }}
                        className={`btn-green ${totalLimitMiner < 1 &&
                          totalLimitNode < 1 &&
                          totalLimitMega < 1 &&
                          totalLimitStandered < 1
                          ? 'fadebuttonss disabled'
                          : ''
                          }`}
                        style={{
                          pointerEvents:
                            totalLimitMiner < 1 &&
                              totalLimitNode < 1 &&
                              totalLimitMega < 1 &&
                              totalLimitStandered < 1
                              ? 'none'
                              : 'auto',
                        }}
                      >
                        {totalLimitMiner < 1 &&
                          totalLimitNode < 1 &&
                          totalLimitMega < 1 &&
                          totalLimitStandered < 1
                          ? 'Maxed Out'
                          : t('Btn-buynow')}
                      </a>
                    ) : (
                      <a
                        onClick={() => {
                          if (
                            !(
                              totalLimitMiner < 1 &&
                              totalLimitNode < 1 &&
                              totalLimitMega < 1 &&
                              totalLimitStandered < 1
                            )
                          ) {
                            toasterror();
                          }
                        }}
                        className={`btn-green fadebuttonss ${totalLimitMiner < 1 &&
                          totalLimitNode < 1 &&
                          totalLimitMega < 1 &&
                          totalLimitStandered < 1
                          ? 'disabled'
                          : ''
                          }`}
                        style={{
                          pointerEvents:
                            totalLimitMiner < 1 &&
                              totalLimitNode < 1 &&
                              totalLimitMega < 1 &&
                              totalLimitStandered < 1
                              ? 'none'
                              : 'auto',
                        }}
                      >
                        {
                           t('Btn-buynow')}
                      </a>
                    )}
                  </>

                </div>
              )
            }

            {
              listinAll?.includes("MATCHAIN") && (
                <div className="single-card" style={{
                  opacity:
                    totalLimitmatchain < 1 && account
                      ? 0.5
                      : 1,
                }}>
                  <Link to="/matchain">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\alldetailpages\matchain\banner\token-logo.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <div className="token-info">
                      <h6>
                        Matchain{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">Genesis License</p>
                      <p className="para">
                        {t('Cre83')}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                          <p>Round</p>
                          <h6>{matchainRound}</h6>
                        </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${roundPricematchain}</h6>
                      </div>
                      {/* <div className="text">
                          <p>Total Raised</p>
                          <h6>--</h6>
                        </div> */}
                    </div>
                  </Link>

                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          if (totalLimitmatchain >= 1) {
                            handleShowBuyNftMatchain();
                          }
                        }}
                        target="_blank"
                        className={`btn-green ${totalLimitmatchain < 1 ? 'fadebuttonss disabled' : ''
                          }`}
                        style={{
                          pointerEvents: totalLimitmatchain < 1 ? 'none' : 'auto',
                        }}
                      >
                        {totalLimitmatchain < 1 ? 'Maxed Out' : t('Btn-buynow')}
                      </a>
                    ) : (
                      <a
                        onClick={(e) => {
                          if (totalLimitmatchain >= 1) {
                            toasterror();
                          }
                        }}
                        target="_blank"
                        className={`btn-green fadebuttonss ${totalLimitmatchain < 1 ? 'disabled' : ''
                          }`}
                        style={{
                          pointerEvents: totalLimitmatchain < 1 ? 'none' : 'auto',
                        }}
                      >
                        { t('Btn-buynow')}
                      </a>
                    )}
                  </>



                  {/* 
                    {status11 === "Ended" ? (
                      <a
                        href="https://buyrain.gems.vip/"
                        target="_blank"
                        className="btn-green"
                      >
                        Sold Out
                      </a>
                    ) : (
                      <a
                        onClick={() => handleShow("MATCHAIN")}
                        target="_blank"
                        className="btn-green"
                      >
                        {t('Btn-buynow')}
                      </a>
                    )} */}
                </div>
              )
            }

            {
              listinAll?.includes("ASTRANOVA") && (
                <div className="single-card" style={{
                  opacity:
                    totalLimitAstaranova < 1 && account
                      ? 0.5
                      : 1,
                }}>
                  <Link to="/astranova">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\alldetailpages\astra\banner\token-logonew.png"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <div className="token-info">
                      <h6>
                        Astra Nova{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">RVV</p>
                      <p className="para">
                        {t('Cre84')}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                          <p>Round</p>
                          <h6>{matchainRound}</h6>
                        </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${roundPriceAstaranova}</h6>
                      </div>
                      {/* <div className="text">
                          <p>Total Raised</p>
                          <h6>--</h6>
                        </div> */}
                    </div>
                  </Link>

                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          console.log("Clicked", totalLimitAstaranova)
                          if (totalLimitAstaranova >= 1) {

                            handleShow(
                              "ASTRANOVA",
                              "Astranova",
                              roundPriceAstaranova,
                              "/assets/alldetailpages/astra/banner/token-logonew.png",
                              purchaseLimitAstaranova,
                              totalLimitAstaranova,
                              purchaseLimitAstaranovaFinalBuying,
                              3
                            );
                          }
                        }}
                        target="_blank"
                        className={`btn-green ${totalLimitAstaranova < 1 ? "fadebuttonss disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitAstaranova < 1 ? "none" : "auto",
                        }}
                      >
                        {totalLimitAstaranova < 1 ? "Maxed Out" : t("Btn-buynow")}
                      </a>
                    ) : (
                      <a
                        onClick={(e) => {
                          if (totalLimitAstaranova >= 1) {
                            toasterror();
                          }
                        }}
                        target="_blank"
                        className={`btn-green fadebuttonss ${totalLimitAstaranova < 1 ? "disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitAstaranova < 1 ? "none" : "auto",
                        }}
                      >
                        {t("Btn-buynow")}
                      </a>
                    )}
                  </>

                  {/* 
                    {status11 === "Ended" ? (
                      <a
                        href="https://buyrain.gems.vip/"
                        target="_blank"
                        className="btn-green"
                      >
                        Sold Out
                      </a>
                    ) : (
                      <a
                        onClick={() => handleShow("MATCHAIN")}
                        target="_blank"
                        className="btn-green"
                      >
                        {t('Btn-buynow')}
                      </a>
                    )} */}
                </div>
              )
            }

            {/* <div className="single-card">
              <Link to="/astranova">
                <div className="main-token-img">
                  <img
                    width={70}
                    height={70}
                    src="\assets\alldetailpages\astra\banner\token-logonew.png"
                    alt="img"
                    className="img-fluid"
                  />
                </div>
                <div className="token-info">
                  <h6>
                    Astra Nova{" "}
                    <span>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                          fill="#30F1B6"
                        />
                      </svg>
                       {t('Verifiedgems')}
                    </span>
                  </h6>
                  <p className="sub-title">$RVV</p>
                  <p className="para">
                    Astra Nova is an AGI-driven gaming ecosystem that
                    evolves with player behavior...
                  </p>
                </div>
                <div className="tokenprice-info">
                  <div className="text">
                    <p>Round</p>
                    <h6>4</h6>
                  </div>
                  <div className="text">
                    <p>{t('Process-t3')}</p>
                    <h6>$0.005</h6>
                  </div>
                  <div className="text">
                    <p>Total Raised</p>
                    <h6>--</h6>
                  </div>
                </div>
              </Link>
              <div className="round-info">
                <h6>
                  {status1}
                </h6>
                <h6>
                  {day1 ? day1 : 0}D : {hour1 ? hour1 : 0}H :{" "}
                  {min1 ? min1 : 0}M : {sec1 ? sec1 : 0}S
                </h6>
              </div>
              {status1 === "Ended" ? (
                <a
                  href="https://buyrain.gems.vip/"
                  target="_blank"
                  className="btn-green"
                >
                  Sold Out
                </a>
              ) : (
                <a
                  onClick={() => handleShow("ASTRONOVA")}
                  target="_blank"
                  className="btn-green"
                >
                  {t('Btn-buynow')}
                </a>
              )}
            </div> */}
            {/* disabledcard */}
            {
              listinAll?.includes("RAIN") && (
                <div className="single-card" style={{ opacity: totalLimitrain < 1 && account ? 0.5 : 1 }}>
                  <Link to="/rain">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\alldetailpages\miners\otherprojects\rain-token.png"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <div className="token-info">
                      <h6>
                        Rain{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">RAIN</p>
                      <p className="para">
                        {t('Cre85')}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                          <p>Round</p>
                          <h6>{rainRound}</h6>
                        </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${roundPrice}</h6>
                      </div>
                      {/* <div className="text">
                          <p>Total Raised</p>
                          <h6>--</h6>
                        </div> */}
                    </div>
                  </Link>

                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          if (totalLimitrain >= 1) {
                            handleShow(
                              "RAIN",
                              "Rain",
                              roundPrice,
                              "/assets/alldetailpages/miners/otherprojects/rain-token.png",
                              purchaseLimitRain,
                              totalLimitrain,
                              purchaseLimitRainFinalBuying,
                              4
                            );
                          }
                        }}
                        target="_blank"
                        className={`btn-green ${totalLimitrain < 1 ? "fadebuttonss disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitrain < 1 ? "none" : "auto",
                        }}
                      >
                        {totalLimitrain < 1 ? "Maxed Out" : t("Btn-buynow")}
                      </a>
                    ) : (
                      <a
                        onClick={(e) => {
                          if (totalLimitrain >= 1) {
                            toasterror();
                          }
                        }}
                        target="_blank"
                        className={`btn-green fadebuttonss ${totalLimitrain < 1 ? "disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitrain < 1 ? "none" : "auto",
                        }}
                      >
                        {t("Btn-buynow")}
                      </a>
                    )}
                  </>
                </div>
              )
            }

            {/* activeSales.includes("OLYMPUS") */}
            {
              listinAll?.includes("OLYMPUS") && (
                <div className="single-card" style={{ opacity: totalLimitolympus < 1 && account ? 0.5 : 1 }}>
                  <Link to="/olympus">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\presaletokens\olympus.png"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <div className="token-info">
                      <h6>
                        Olympus AI{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">OAI</p>
                      <p className="para">
                        {t('Cre86')}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                          <p>Round</p>
                          <h6>{OlympusRound ? OlympusRound : "---"}</h6>
                        </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${roundPriceOlympus ? roundPriceOlympus : "---"}</h6>
                      </div>
                      {/* <div className="text">
                          <p>Total Raised</p>
                          <h6>--</h6>
                        </div> */}
                    </div>
                  </Link>

                  {/* {
                      !timeshow
                        ? */}
                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          if (totalLimitolympus >= 1) {
                            handleShow(
                              "OLYMPUS",
                              "Olympus AI",
                              roundPriceOlympus,
                              "/assets/presaletokens/olympus.png",
                              purchaseLimitOlympus,
                              totalLimitolympus,
                              purchaseLimitOlympusFinalBuying,
                              5
                            );
                          }
                        }}
                        target="_blank"
                        className={`btn-green ${totalLimitolympus < 1 ? "fadebuttonss disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitolympus < 1 ? "none" : "auto",
                        }}
                      >
                        {totalLimitolympus < 1 ? "Maxed Out" : t("Btn-buynow")}
                      </a>
                    ) : (
                      <a
                        onClick={(e) => {
                          if (totalLimitolympus >= 1) {
                            toasterror();
                          }
                        }}
                        target="_blank"
                        className={`btn-green fadebuttonss ${totalLimitolympus < 1 ? "disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitolympus < 1 ? "none" : "auto",
                        }}
                      >
                        {t("Btn-buynow")}
                      </a>
                    )}
                  </>

                  {/* <a
                      onClick={() => handleShow("OLYMPUS", "Olympus AI", roundPriceOlympus, "/assets/presaletokens/olympus.png")}
                      target="_blank"
                      className="btn-green">
                      {t('Btn-buynow')}
                    </a> */}
                  {/* // : */}

                  {/* <Link to="/olympus" className="btn-buy">
                      {t('Process-t7')}
                    </Link> */}

                  {/* } */}
                </div>
              )
            }

            {
              listinAll?.includes("LEIA") && (
                <div className="single-card">
                  <Link to="/leia">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\presaletokens\leia.png"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>

                    <div className="token-info">
                      <h6>
                        LEIA{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">LEIA</p>
                      <p className="para">
                        {t('Cre87')}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                            <p>Round</p>
                            <h6>--</h6>
                          </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>--</h6>
                      </div>
                      {/* <div className="text">
                            <p>Total Raised</p>
                            <h6>$3,300,000+</h6>
                          </div> */}
                    </div>
                  </Link>

                  {/* {
                      !timeshow1
                        ?
                        <a
                          href="https://leia.gems.vip"
                          target="_blank"
                          className="btn-buy">
                          {t('Btn-buynow')}
                        </a>
                        : */}

                  <Link to="/leia" className="btn-buy">
                    {t('Process-t7')}
                  </Link>

                  {/* } */}
                </div>
              )
            }

            {
              listinAll?.includes("INCENTIV") && (
                <div className="single-card" style={{ opacity: totalLimitIncentive < 1 && account ? 0.5 : 1 }}>
                  <Link to="/incentiv">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\presaletokens\incentiv.png"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>

                    <div className="token-info">
                      <h6>
                        Incentiv{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">CENT</p>
                      <p className="para">
                        {t('Cre88')}{" "}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                            <p>Round</p>
                            <h6>--</h6>
                          </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${roundPriceincentive}</h6>
                      </div>
                      {/* <div className="text">
                            <p>Total Raised</p>
                            <h6>$25,000,000+</h6>
                          </div> */}
                    </div>
                  </Link>
                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          if (totalLimitIncentive >= 1) {
                            handleShow(
                              "INCENTIV",
                              "Incentiv",
                              roundPriceincentive,
                              "/assets/presaletokens/incentiv.png",
                              purchaseLimitIncentive,
                              totalLimitIncentive,
                              purchaseLimitIncentiveFinalBuying,
                              6
                            );
                          }
                        }}
                        target="_blank"
                        className={`btn-green ${totalLimitIncentive < 1 ? "fadebuttonss disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitIncentive < 1 ? "none" : "auto",
                        }}
                      >
                        {totalLimitIncentive < 1 ? "Maxed Out" : t("Btn-buynow")}
                      </a>
                    ) : (
                      <a
                        onClick={(e) => {
                          if (totalLimitIncentive >= 1) {
                            toasterror();
                          }
                        }}
                        target="_blank"
                        className={`btn-green fadebuttonss ${totalLimitIncentive < 1 ? "disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitIncentive < 1 ? "none" : "auto",
                        }}
                      >
                        {t("Btn-buynow")}
                      </a>
                    )}
                  </>

                  {/* <Link to="/incentiv" className="btn-buy">
                    {t('Process-t7')}
                  </Link> */}
                </div>
              )
            }
            {
              listinAll?.includes("GEMS") && (
                <div className="single-card">
                  <Link to="/gemsdetail">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\alldetailpages\gemsdetailpage\info\token-logo.png"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>

                    <div className="token-info">
                      <h6>
                        Gems{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">Gems</p>
                      <p className="para">
                        {t('Cre89')}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                            <p>Round</p>
                            <h6>--</h6>
                          </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>--</h6>
                      </div>
                      {/* <div className="text">
                            <p>Total Raised</p>
                            <h6>$10,000,000+</h6>
                          </div> */}
                    </div>
                  </Link>

                  <Link to="/gemsdetail" className="btn-buy">
                    {t('Process-t7')}
                  </Link>
                </div>
              )
            }
            {
              listinAll?.includes("DOP") && <div className="single-card">
                <Link to="/dopdetail">
                  <div className="main-token-img">
                    <img
                      width={70}
                      height={70}
                      src="\assets\presaletokens\dop.png"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>

                  <div className="token-info">
                    <h6>
                      DOP{" "}
                      <span>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="12"
                          viewBox="0 0 13 12"
                          fill="none"
                        >
                          <path
                            d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                            fill="#30F1B6"
                          />
                        </svg>
                        {t('Verifiedgems')}
                      </span>
                    </h6>
                    <p className="sub-title">DATA OWNERSHIP PROTOCOL</p>
                    <p className="para">
                      {t('Cre90')}
                    </p>
                  </div>
                  <div className="tokenprice-info">
                    {/* <div className="text">
                          <p>Round</p>
                          <h6>--</h6>
                        </div> */}
                    <div className="text">
                      <p>{t('Process-t3')}</p>
                      <h6>--</h6>
                    </div>
                    {/* <div className="text">
                          <p>Total Raised</p>
                          <h6>$160,000,000+</h6>
                        </div> */}
                  </div>
                </Link>

                <Link to="/dopdetail" className="btn-buy">
                  {t('Process-t7')}
                </Link>
              </div>
            }
            {
              listinAll?.includes("NFA") && (
                <div className="single-card" style={{ opacity: totalLimitNFA < 1 && account ? 0.5 : 1 }}>
                  <Link to="/nfa">
                    <div className="main-token-img">
                      <img
                        width={70}
                        height={70}
                        src="\assets\alldetailpages\nfa\token-logo.png"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <div className="token-info">
                      <h6>
                        NFA{" "}
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <path
                              d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                              fill="#30F1B6"
                            />
                          </svg>
                          {t('Verifiedgems')}
                        </span>
                      </h6>
                      <p className="sub-title">NFA</p>
                      <p className="para">
                        {t('Cre91')}
                      </p>
                    </div>
                    <div className="tokenprice-info">
                      {/* <div className="text">
                            <p>Round</p>
                            <h6>--</h6>
                          </div> */}
                      <div className="text">
                        <p>{t('Process-t3')}</p>
                        <h6>${roundPriceNFA}</h6>
                      </div>
                      {/* <div className="text">
                            <p>Total Raised</p>
                            <h6>$289,000+</h6>
                          </div> */}
                    </div>
                  </Link>
                  <>
                    {account ? (
                      <a
                        onClick={() => {
                          if (totalLimitNFA >= 1) {
                            handleShow(
                              "NFA",
                              "NFA",
                              roundPriceNFA,
                              "/assets/alldetailpages/nfa/token-logo.png",
                              purchaseLimitNFA,
                              totalLimitNFA,
                              purchaseLimitNFAFinalBuying,
                              7
                            );
                          }
                        }}
                        target="_blank"
                        className={`btn-green ${totalLimitNFA < 1 ? "fadebuttonss disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitNFA < 1 ? "none" : "auto",
                        }}
                      >
                        {totalLimitNFA < 1 ? "Maxed Out" : t("Btn-buynow")}
                      </a>
                    ) : (
                      <a
                        onClick={(e) => {
                          if (totalLimitNFA >= 1) {
                            toasterror();
                          }
                        }}
                        target="_blank"
                        className={`btn-green fadebuttonss ${totalLimitNFA < 1 ? "disabled" : ""
                          }`}
                        style={{
                          pointerEvents: totalLimitNFA < 1 ? "none" : "auto",
                        }}
                      >
                        {t("Btn-buynow")}
                      </a>
                    )}
                  </>

                  {/* <Link to="/nfa" className="btn-buy">
                    {t('Process-t7')}
                  </Link> */}
                </div>
              )
            }


          </div>
        </div>
      </section>
      {/* <button onClick={handleShow}>dsfdg</button> */}
      <Modal
        className="buymodal common-modal-style"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Buy')} {'$'+(nameSale === "Luckify" || nameSale === "luckify" ? "luck" : nameSale)?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="upperbuy">
            <div className="tokenleft">
              <div className="tokenmain">
                <img
                  src={imageGeneric}
                  alt="tokenimg"
                  className="tokenimg"
                />
              </div>
              <h4 className="tokenhead">{nameSale}</h4>
            </div>
            <div className="tokenright">
              <p className="pricepara">{t('Gems-detailt7')}</p>
              <h6 className="dollarpara">${roundPricegeneric}</h6>
            </div>
          </div>
          <div className="inputsmain">
            <div className="upperinput">
              <div className="paymain">
                <p className="paypara">{t('Cre92')}</p>
                <p className="creditpara">{t('Cre93')} {balance?.toFixed(6)}</p>
              </div>
              <div className="inputmain">
                <input value={valueinput} onChange={(e) => setvalueinput(e.target.value)} placeholder="0" type="number" className={color === true ? "asdadasdkasdaklsdj maininnerinput" : "maininnerinput"} />
                <button onClick={MaxFunc} className="maxbtn">{t('Cre25')}</button>
              </div>
            </div>
            <span className="arrowimg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
              >
                <path
                  d="M2.23621 9.95642L2.23621 12.8487L9.24455 16.7719L9.24455 13.8796L2.23621 9.95642Z"
                  fill="#02171D"
                />
                <path
                  d="M16.2676 9.95642L16.2676 12.8487L9.25924 16.7719L8.04764 14.9491L9.25924 13.8796L16.2676 9.95642Z"
                  fill="#02171D"
                />
                <path
                  d="M7.92847 9.80906L7.92847 1.77884L10.5713 3.25274L10.5713 11.283L7.92847 9.80906Z"
                  fill="#02171D"
                />
              </svg>
            </span>
            <div className="lowerinput">
              <div className="paymain">
                <p className="paypara">{t('Cre94')}</p>
                {/* <p className="paypara">You Get Tokens</p> */}
              </div>
              <div className="inputmain">
                <input placeholder="0" value={youGet ? youGet?.toLocaleString() : 0} type="text" className="maininnerinput" />
                <div className="tokenleft">
                  <div className="tokenmain">
                    <img
                      src={imageGeneric}
                      alt="tokenimg"
                      className="tokenimg"
                    />
                  </div>
                  <h4 className="tokenhead">{(nameSale === "Luckify" || nameSale === "luckify" ? "luck" : nameSale)?.toUpperCase()}</h4>
                </div>
              </div>
            </div>
          </div>
          <p className="text-danger">{inputError}</p>
          <div className="refundlimit" style={nameSale === "incentiv" ? { marginBottom: "14px" } : {}}>
            <h6>{t('Cre95')}</h6>
            <h6>
              {
                nameSale === "Screx" ? purchaseLimitPeruserScrex?.toLocaleString() :
                nameSale === "Rain" ? purchaseLimitRain?.toLocaleString() :
                  nameSale === "Astranova" ? purchaseLimitAstaranova?.toLocaleString() :
                    nameSale === "Incentiv" ? purchaseLimitIncentive?.toLocaleString() :
                      nameSale === "NFA" ? purchaseLimitNFA?.toLocaleString() :
                        projectselected === "OLYMPUS" ? purchaseLimitOlympus?.toLocaleString() :
                          projectselected === "LUCKIFY" ? purchaseLimitPeruserLuckify?.toLocaleString() :
                            ""
              }{" "}
              {
                nameSale === "Screx" ? "Screx" :
                nameSale === "Rain" ? "Rain" :
                  nameSale === "Astranova" ? "Astranova" :
                    nameSale === "Incentiv" ? "Incentiv" :
                      nameSale === "NFA" ? "NFA" :
                        projectselected === "OLYMPUS" ? "Olympus" :
                          projectselected === "LUCKIFY" ? "LUCK" :
                            ""
              } / User
            </h6>
          </div>
          {

            nameSale === "Incentiv" && (
              <div className="inc-warning">
                <p>{t('Cre96')} <span>18 months</span></p>
              </div>
            )
          }

          <div className="bottombtns">
            {/* <button className="backbtn">Back</button> */}
            <button
              // disabled
              className={isInputError === true ? "buybtn fadebuttonheres" : "buybtn"}
              onClick={() => {
                Purchasetoken();
              }}
            >
              {t('Buy')} {'$'+(nameSale === "Luckify" || nameSale === "luckify" ? "luck" : nameSale)?.toUpperCase()}
            </button>
          </div>
        </Modal.Body>
      </Modal>


      <Modal
        className="buymodal common-modal-style"
        show={buynft}
        onHide={handleCloseBuyNft}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Buy')} Gems Miners</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buynft-flow">
            <div className="upper-content">
              <div className="twice-labels">
                <h6>{t('Cre98')}</h6>
                <p>{t('Cre99')}  {balance?.toFixed(6)}</p>
              </div>
              <div className="dropdown">
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedMiner ? (
                    <div className="when-valueselect">
                      <div className="left-side">
                        <div className="main-img">
                          <img src={selectedMiner.img} alt="img" className="img-fluid" />
                        </div>
                        <div className="text">
                          <h6>{selectedMiner.name}</h6>
                          <p>${selectedMiner.price}</p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {t('Cre100')}{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M6 9L12 15L18 9"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </>
                  )}
                </button>

                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  {miners?.map((miner) => {
                    const isDisabled = !listinAll?.includes(miner.apivalue);
                    const isSelected = selectedMiner?.key === miner.key;
                    return (
                      <li className={isDisabled ? "ertedsverheerbererb" : ""} key={miner.key}>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            if (!isDisabled) setSelectedMiner(miner);
                          }}
                        // style={{
                        //   cursor: isDisabled ? "not-allowed" : "pointer",
                        //   opacity: isDisabled ? 0.8 : 1,
                        // }}
                        >
                          <div className="left-side">
                            <div className="main-img">
                              <img src={miner.img} alt="img" className="img-fluid" />
                            </div>
                            <div className="text">
                              <h6>{miner.name}</h6>
                              <p>${miner.price}</p>
                            </div>
                          </div>
                          {isSelected && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="green"
                              viewBox="0 0 16 16"
                            >
                              <path d="M13.485 1.929a1 1 0 0 1 1.415 1.415l-8.072 8.072a1 1 0 0 1-1.414 0L1.1 7.586a1 1 0 0 1 1.414-1.414L6 9.657l7.485-7.728z" />
                            </svg>
                          )}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="select-nft-flow">
              <h6>{t('Cre101')}</h6>
              <div className="quantity-flow">
                <a
                  onClick={() => {
                    if (selectedMiner) decrement();
                  }}
                  style={{ cursor: selectedMiner ? "pointer" : "not-allowed", opacity: selectedMiner ? 1 : 0.5 }}
                >
                  -
                </a>

                <p className={colorr === true ? "asdadasdkasdaklsdj" : ""}>{quantity}</p>

                <a
                  onClick={() => {
                    if (selectedMiner) increment();
                  }}
                  style={{ cursor: selectedMiner ? "pointer" : "not-allowed", opacity: selectedMiner ? 1 : 0.5 }}
                  className={selectedMiner ? "active" : ""}
                >
                  +
                </a>
              </div>
            </div>
            <p className="text-danger">{inputErrorr}</p>
            {selectedMiner && quantity > 0 &&
              (
                <div className="when-select">
                  <div className="single-value">
                    <h6>{selectedMiner?.name}</h6>
                    <h5>x{totalIncrementCount ? totalIncrementCount : 0} <span>(${totalPrice ? totalPrice?.toFixed(2) : 0})</span></h5>
                  </div>
                  <div className="single-value">
                    <h6>{t('Cre102')}</h6>
                    <h5>{totalPrice ? totalPrice?.toFixed(2) : 0} <span>(${totalPrice ? totalPrice?.toFixed(2) : 0} )</span></h5>
                  </div>
                </div>
              )
            }

            <div className="refundlimit">
              <h6>{t('Cre95')}</h6>
              <h6>
                {
                  selectedMiner?.key === "mini" ? purchaseLimitMiner :
                    selectedMiner?.key === "standard" ? purchaseLimitStandered :
                      selectedMiner?.key === "mega" ? purchaseLimitMega :
                        selectedMiner?.key === "node" ? purchaseLimitNode : 0
                }{" "}
                {
                  selectedMiner?.key === "mini" ? "Mini Miner" :
                    selectedMiner?.key === "standard" ? "Standard Miner" :
                      selectedMiner?.key === "mega" ? "Mega Miner" :
                        selectedMiner?.key === "node" ? "Gems Node" : ""
                } / User
              </h6>
            </div>

            <div className="twice-btns">
              <button onClick={handleCloseBuyNft} className="btn-back">Cancel</button>
              <button onClick={PurchaseNFTNodeMiner} className={isInputErrorr === true ? "btn-green fadebuttonheres" : "btn-green"}>Buy {selectedMiner?.key === "node" ? "Node" : "Miner"}</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="buymodal common-modal-style"
        show={buynftmatchain}
        onHide={handleCloseBuyNftMatchain}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Buy')} Matchain</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buynft-flow">
            <div className="upper-content">
              <div className="twice-labels">
                <h6>{t('Cre98')}</h6>
                <p>{t('Cre99')} {balance?.toFixed(6)}</p>
              </div>
              <div class="dropdown">
                <button class="dropdown-toggle" type="button" id="dropdownMenuButton1" >
                  {/* Select Miner Type <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9L12 15L18 9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg> */}
                  <div className="when-valueselect">
                    <div className="left-side">
                      <div className="main-img">
                        <img src="\assets\creditrefund\buynft\matchainnft\1.svg" alt="img" className="img-fluid" />
                      </div>
                      <div className="text">
                        <h6>Genesis License</h6>
                        <p>${roundPricematchain}</p>
                      </div>
                    </div>
                  </div>
                </button>
                {/* <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li><a class="dropdown-item">
                    <div className="left-side">
                      <div className="main-img">
                        <img src="\assets\creditrefund\buynft\matchainnft\1.svg" alt="img" className="img-fluid" />
                      </div>
                      <div className="text">
                        <h6>Genesis License</h6>
                        <p>$262.5</p>
                      </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                      <path d="M13.0003 5.73706L13.0003 0.588867L5.15655 8.41302L0.480469 5.11411L0.480469 9.88688L5.15655 13.4104L13.0003 5.73706Z" fill="#329879" />
                    </svg>
                  </a></li>
                  <li><a class="dropdown-item">
                    <div className="left-side">
                      <div className="main-img">
                        <img src="\assets\creditrefund\buynft\matchainnft\2.svg" alt="img" className="img-fluid" />
                      </div>
                      <div className="text">
                        <h6>Mega License (Buy 10 Get 11)</h6>
                        <p>$2,625</p>
                      </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                      <path d="M13.0003 5.73706L13.0003 0.588867L5.15655 8.41302L0.480469 5.11411L0.480469 9.88688L5.15655 13.4104L13.0003 5.73706Z" fill="#329879" />
                    </svg>
                  </a></li>
                </ul> */}
              </div>
            </div>
            <div className="select-nft-flow">
              <h6>{t('Cre101')}</h6>
              <div className="quantity-flow">
                <a onClick={decrements}>-</a>
                <p className={colorrr === true ? "asdadasdkasdaklsdj" : ""}>{quantitys}</p>
                <a onClick={increments} className="active">+</a>
              </div>
            </div>
            <p className="text-danger">{inputErrorrr}</p>
            {quantitys > 0 &&
              (
                <div className="when-select">
                  <div className="single-value">
                    <h6>Genesis License</h6>
                    <h5>x{totalIncrementCounts} <span>(${totalPrices ? totalPrices : 0})</span></h5>
                  </div>
                  <div className="single-value">
                    <h6>{t('Cre102')}</h6>
                    <h5>{totalPrices ? totalPrices : 0} <span>(${totalPrices ? totalPrices : 0})</span></h5>
                  </div>
                </div>
              )
            }

            <div className="refundlimit">
              <h6>{t('Cre95')}</h6>
              <h6>{purchaseLimitMatchain} Genesis License / User</h6>
            </div>

            <div className="twice-btns">
              <button onClick={handleCloseBuyNftMatchain} className="btn-back">{t('pre28')}</button>
              <button onClick={PurchaseMatChainNft} className={isInputErrorrr === true ? "btn-green fadebuttonheres" : "btn-green"}>{t('Buy')} Matchain</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="buymodal common-modal-style"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{'$' + (nameSale === "Luckify" || nameSale === "luckify" ? "luck" : nameSale)?.toUpperCase()} Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="88"
            viewBox="0 0 89 88"
            fill="none"
            className="tickimg"
          >
            <path
              d="M77.083 37.9845L77.083 11.417L35.6296 51.7939L10.917 34.7697L10.917 59.3998L35.6296 77.583L77.083 37.9845Z"
              fill="#02171D"
            />
          </svg>
          <h4 className="purchasehead">{'$' + (nameSale === "Luckify" || nameSale === "luckify" ? "luck" : nameSale)?.toUpperCase()} {t('Cre103')}</h4>
          <p className="purchasepara">{t('A confirmation mail will be sent to the email address linked to the wallet you used to connect.')}</p>
          <div className="detailmain">
            <div className="detailinner">
              <h6 className="innerleft">{t('Cre105')}</h6>
              <p className="innerright">
                {valueinput1
                  ? (valueinput1 / roundPricegeneric).toLocaleString(undefined, {
                    minimumFractionDigits: 3,
                    maximumFractionDigits: 3,
                  })
                  : "0.000"}{" "}                {(nameSale === "Luckify" || nameSale === "luckify" ? "luck" : nameSale)?.toUpperCase()}
              </p>
            </div>
            <div className="creditinner">
              <h6 className="creditleft">{t('Cre106')}</h6>
              <p className="creditright">
                {valueinput1 ? valueinput1 : 0} <span>(${valueinput1 ? valueinput1 : 0})</span>
              </p>
            </div>
          </div>
          <button onClick={handleClose1} className="okaybtn">
            Okay
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        className="buymodal common-modal-style"
        show={show122}
        onHide={handleClose122}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedMiner2?.name} Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="88"
            viewBox="0 0 89 88"
            fill="none"
            className="tickimg"
          >
            <path
              d="M77.083 37.9845L77.083 11.417L35.6296 51.7939L10.917 34.7697L10.917 59.3998L35.6296 77.583L77.083 37.9845Z"
              fill="#02171D"
            />
          </svg>
          <h4 className="purchasehead">{selectedMiner2?.name} {t('Cre103')}</h4>
          <p className="purchasepara">{t('Cre104')}</p>
          <div className="detailmain">
            <div className="detailinner">
              <h6 className="innerleft">{selectedMiner2?.name}</h6>
              <p className="innerright">x{totalIncrementCountM} (${totalPriceM ? totalPriceM?.toFixed(2) : 0}) </p>
            </div>
            <div className="creditinner">
              <h6 className="creditleft">{t('Cre106')}</h6>
              <p className="creditright">
                ${totalPriceM ? totalPriceM?.toFixed(2) : 0} <span>(${totalPriceM ? totalPriceM?.toFixed(2) : 0})</span>
              </p>
            </div>
          </div>
          <button onClick={handleClose122} className="okaybtn">
            OK
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        className="buymodal common-modal-style"
        show={show1222}
        onHide={handleClose1222}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Matchain Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="88"
            viewBox="0 0 89 88"
            fill="none"
            className="tickimg"
          >
            <path
              d="M77.083 37.9845L77.083 11.417L35.6296 51.7939L10.917 34.7697L10.917 59.3998L35.6296 77.583L77.083 37.9845Z"
              fill="#02171D"
            />
          </svg>
          <h4 className="purchasehead">Matchain {t('Cre103')}</h4>
          <p className="purchasepara">{t('Cre107')}</p>
          <div className="detailmain">
            <div className="detailinner">
              <h6 className="innerleft">Genesis License</h6>
              <p className="innerright">x{totalIncrementCountsM} (${totalPricesM ? totalPricesM : 0})</p>
            </div>
            <div className="creditinner">
              <h6 className="creditleft">{t('Cre106')}</h6>
              <p className="creditright">
                {totalPricesM ? totalPricesM : 0} <span>(${totalPricesM ? totalPricesM : 0})</span>
              </p>
            </div>
          </div>
          <button onClick={handleClose1222} className="okaybtn">
            OK
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        className="fundsmodal common-modal-style"
        show={show22}
        onHide={handleClose22}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Oops</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <div className="upperimg">
              <img
                src="\assets\redcrossimg.png"
                alt="img"
                className="crossimg img-fluid"
              />
            </div>
            <p className="maxwidthset">
              {t('Cre108')}
            </p>
            <div className="lastbutton">
              <button onClick={handleClose22} className="cancle">{t('pre28')}</button>
              <button
                className="get"
                onClick={() => {
                  // handleShow22();
                  navigator();
                }}
              >
                {t('Cre5')}{" "}


              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      <Modal
        className="common-modal-style followusonx-modal verificationemail-modal"
        show={showverify}
        onHide={handleCloseVerify}
        centered
        backdrop="static"        // prevents closing on outside click
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="verification-modal">
            <p className="para">
              We will email you a 6-digit code to verify your email address. Enter the code below.
            </p>

            <div className="option-field">
              <label>Email Address</label>
              <div className="inside-input">
                <input
                  type="text"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={handleEmailChange}
                />
                <a
                  href="#"
                  className={`btn-send ${!isEmailValid || isResendDisabled ? "disabled" : ""}`}
                  onClick={handleSendCode}
                  style={{
                    pointerEvents: !isEmailValid || isResendDisabled ? "none" : "auto",
                    opacity: !isEmailValid || isResendDisabled ? 0.5 : 1,
                  }}
                >
                  {isResendDisabled ? `Resend in ${timer}s` : "Send Code"}
                </a>

              </div>
            </div>

            <div style={{ opacity: showOtpInput ? 1 : 0.5, pointerEvents: showOtpInput ? "auto" : "none" }}>
              <div className="option-field" style={{ marginTop: "25px" }}>
                <label style={{ color: "var(--V6-Dark-Theme-Secondary-Text-Color)" }}>
                  Verification Code
                </label>
                <div className="inside-input">
                  <input
                    type="text"
                    placeholder="Enter 6-digit code here"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>
              </div>

              {!isOtpValid && (
                <p className="error-text">Invalid email verification code</p>
              )}

              <div className="twice-btnsss">
                <button
                  className={`btn-green sscscscscscsc ${otp.length !== 6 ? "disabled" : ""}`}
                  style={{ marginTop: "28px" }}
                  onClick={handleVerifyOtp}
                  disabled={otp.length !== 6}
                >
                  Verify Code
                </button>
              </div>
            </div>

          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="common-modal-style connectwallet-modal nooreee learnmore-modal"
        show={creditTerms}
        onHide={handleCloseCreditTerms}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title> <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <rect y="0.5" width="24" height="24" rx="4" fill="#E88F35" />
              <path d="M10.0001 2.5L13.4199 4.40802L13.5063 17.6429L10.0866 15.7348L10.0001 2.5Z" fill="white" />
              <path d="M9.9999 17.604L13.4196 19.512L13.5061 21.604L10.0864 19.696L9.9999 17.604Z" fill="white" />
            </svg>{t('Cre39')}</div> </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="disclaimerdiv">
            <div className="darktext">
              <div className="scrolltext">
                <p className="darkparaupper text-center">{t('Cre40')}</p>
                <p className="darkpara text-center">
                  {t('Cre41')} 28 April 2025
                </p>
                <p className="darkpara">
                  1.
                  <span className="headingtext formarginleft">{t('Cre42')}</span>
                </p>
                <p className="darkpara">
                  {t('Cre43')}
                </p>

                <p className="darkpara">
                  2.
                  <span className="headingtext formarginleft">
                    {t('Cre44')}
                  </span>
                </p>
                <p className="darkpara">
                  {t('Cre45')}
                </p>

                <p className="darkpara">
                  3.<span className="headingtext formarginleft">{t('Cre46')}</span>
                </p>
                <p className="darkpara">
                  {t('Cre47')}
                </p>

                <p className="darkpara">
                  4.
                  <span className="headingtext formarginleft">
                    {t('Cre48')}
                  </span>
                </p>
                <p className="darkpara">
                  {t('Cre49')}
                </p>

                <p className="darkpara">
                  5.
                  <span className="headingtext formarginleft">
                    {t('Cre50')}
                  </span>
                </p>
                <p className="darkpara">
                  <span className="headingtext formarginleft">5.1</span> {t('Cre51')}
                </p>
                <p className="darkpara">
                  <ul>
                    <li>{t('Cre52')}</li>
                    <li>{t('Cre53')}</li>
                    <li>{t('Cre54')}</li>
                    <li>{t('Cre55')}</li>
                    <li>{t('Cre56')} </li>
                  </ul>
                </p>
                <p className="darkpara">
                  <span className="headingtext formarginleft">5.2</span> {t('Cre57')}
                </p>
                <p className="darkpara">
                  6.
                  <span className="headingtext formarginleft">
                    {t('Cre58')}
                  </span>
                </p>
                <p className="darkpara">
                  {t('Cre59')}
                </p>

                <p className="darkpara">
                  7.<span className="headingtext formarginleft">{t('Cre60')}</span>
                </p>
                <p className="darkpara">
                  {t('Cre61')}

                </p>

                <p className="darkpara">
                  8.
                  <span className="headingtext formarginleft">
                    {t('Cre62')}
                  </span>
                </p>
                <p className="darkpara">{t('Cre63')}</p>


                <p className="darkpara">
                  9.
                  <span className="headingtext formarginleft">
                    {t('Cre64')}
                  </span>
                </p>
                <p className="darkpara">
                  {t('Cre65')}
                </p>

                <p className="darkpara">
                  10.
                  <span className="headingtext formarginleft">{t('Cre66')}</span>
                </p>
                <p className="darkpara">
                  {t('Cre67')}
                </p>
                <p className="darkpara">
                  11.<span className="headingtext formarginleft">{t('Cre68')}</span>
                </p>
                <p className="darkpara">
                  {t('Cre69')}
                </p>

              </div>
            </div>

            {/* Email Field */}
            {/* <div className="option-field" style={{ margin: "20px 0" }}>
                        <div className="material-textfield">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>
                      </div> */}

            {/* Checkbox */}
            <div className="checkboxmainnnnnn">
              <label className="checkbox m-0" htmlFor="ch1">
                <input
                  type="checkbox"
                  id="ch1"
                  onChange={() => setTermsAccepted(!IsTermsAccepted)}
                  checked={IsTermsAccepted}
                />
                <span className="checkmark"></span>
              </label>
              <p className="checkboxpara">{t('Cre70')}</p>
            </div>

            {/* <div className="checkboxmainnnnnn">
              <label className="checkbox m-0" htmlFor="ch2">
                <input
                  type="checkbox"
                  id="ch2"
                  onChange={() => setIsSecondChecked(!isSecondChecked)}
                  checked={isSecondChecked}
                />
                <span className="checkmark"></span>
              </label>
              <p className="checkboxpara">{"I agree to recieve communication and marketing emails from Gems"}</p>
            </div> */}

            {/* <div className="checkboxmainnnnnn">
              <label className="checkbox m-0" htmlFor="ch3">
                <input
                  type="checkbox"
                  id="ch3"
                  onChange={() => setIsThirdChecked(!isThirdChecked)}
                  checked={isThirdChecked}
                />
                <span className="checkmark"></span>
              </label>
              <p className="checkboxpara">{"I hereby confirm I'm not a citizen of United States of America"}</p>
            </div> */}


            {/* Continue Button */}
            <button
              disabled={!(IsTermsAccepted)}
              className="continuebutton"
              style={!(IsTermsAccepted)
                ? { opacity: 0.5, pointerEvents: "none" }
                : {}}
              onClick={() => {
                handleCloseCreditTerms(true);
                // handleShow2();
              }}
            >
              {t('Cre71')}
            </button>

          </div>
        </Modal.Body>

      </Modal>



    </>
  );
};

export default Buy;
